enum TransportStatus {
  Pending = 0,
  Delivered = 2,
};

export default TransportStatus;
